module.exports = __webpack_public_path__ + "dd8e3ee3ce8ba10c48c6546faab36836.jpg";